<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="less">
  @import './style/common';
  @import './style/popbox';
</style>



// WEBPACK FOOTER //
// src/App.vue